import { cn, putComma } from "@/lib/utils";
import { useRef, useEffect, useState } from "react";

const LivePriceBox = ({ ltpPrice, textClass, textColor, isSymbol = true }) => {
    const [value, setValue] = useState(0);
    const prevData = useRef();
    const isFirstRun = useRef(true);

    useEffect(() => {
        if (isFirstRun.current) {
            prevData.current = ltpPrice;
            isFirstRun.current = false;
            return;
        }

        const diff = ltpPrice - prevData.current;
        setValue(diff);
        prevData.current = ltpPrice;

        const timeout = setTimeout(() => setValue(0), 600);
        return () => clearTimeout(timeout);
    }, [ltpPrice]);

    return (
        <div
            style={{ color: textColor ?? "#202020" }}
            className={cn(
                `font-Inter ease-linear duration-200 `,
                value === 0 ? "bg-transparent" : value > 0 ? "bg-[#E0FFE7]" : "bg-[#FFE7E0]",
                textClass
            )}
        >
            {isSymbol ? "₹" : ""}
            {putComma(ltpPrice)}
        </div>
    );
};

export default LivePriceBox;
